import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { searchMedications as searchMedicationsService } from '../../services/medicationService';

const initialState = {
  searchResults: [],
  frequentlyUsed: {}, // Cache for frequently used medications
  loading: false,
  error: null,
};

// Thunk to search for medications
export const searchMedications = createAsyncThunk(
  'medications/searchMedications',
  async (searchTerm) => {
    try {
      // Check cache first
      const cacheKey = `medication_search_${searchTerm.toLowerCase()}`;
      const cached = sessionStorage.getItem(cacheKey);
      
      if (cached) {
        const parsed = JSON.parse(cached);
        return { results: parsed, isCached: true };
      }
      
      // If not in cache, use service layer
      try {
        const results = await searchMedicationsService(searchTerm);
        
        // Cache the results
        sessionStorage.setItem(cacheKey, JSON.stringify(results));
        
        return { results, isCached: false };
      } catch (error) {
        console.error('Error searching medications:', error);
        throw error;
      }
    } catch (error) {
      console.error('Error in searchMedications thunk:', error);
      throw error;
    }
  }
);

const medicationsSlice = createSlice({
  name: 'medications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchMedications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchMedications.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload.results;

        // Update cache if results are not from cache
        if (!action.payload.isCached) {
          action.payload.results.forEach(med => {
            state.frequentlyUsed[med.id] = med;
          });
        }
      })
      .addCase(searchMedications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default medicationsSlice.reducer; 